<template>
  <v-app>

    <OverlayLoading :overlay="globalLoading"></OverlayLoading>

    <OverlayModal :overlay="showPopUp" @dismiss="showPopUp = false" />

    <section v-if="navigation" id="nav-bar"
             class="navbar-section"
             :class="(specialMenuCss) ? 'header-suppressed' : ''">

      <main-menu :context="navigation" id="main-menu">
        <template v-slot:mobile-menu class="socialIcons">
          <v-row v-if="socialIcons && socialIcons.length > 0" class="justify-center">
            <v-col cols="12" class="text-center">
              <v-btn v-for="(item, index) in socialIcons"
                     :key="index"
                     class="ma-1"
                     icon
                     plain
                     link
                     :href="item.iconLink.url"
                     :target="item.iconLink.target">
                <v-icon color="white">{{ item.iconName }}</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </template>

        <template v-slot:search-box>
          <add-search :context="addSearchContext"/>
        </template>
      </main-menu>
    </section>
    <v-main>
      <router-view :key="$route.fullPath"
                   v-if="defaultGlobals"
                   ref="applicationBodyWrapper"
                   @rerenderMenu="rerenderMenu"
                   @triggerOverlayLoading="handleShowLoading"
                   :defaultGlobals="defaultGlobals"
                   @headerSuppressed="headerSuppressed"/>
    </v-main>

  </v-app>
</template>
<script>

import globalMixins from "@/mixins/globalMixins";
import MainMenu from "@/components/MainMenu";
import OverlayLoading from "@/components/OverlayLoading";
import OverlayModal from "@/components/OverlayModal";
import AddSearch from "@/components/AddSearch";

export default {
  name: 'App',
  mixins: [globalMixins],
  components: {
    AddSearch,
    MainMenu,
    OverlayLoading, OverlayModal
  },

  // parent
  metaInfo: {
    title: '',
    titleChunk: '',
    titleTemplate: '%s',
    meta: [
      {
        name: 'og:type',
        content: "website"
      },
      {
        name: 'Content-Type',
        content: 'text/html; charset=utf-8'
      },
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1, shrink-to-fit=no'
      }
    ],
    script: [],
    style: [],
    link: [],
    base: {},
    htmlAttrs: {
      lang: 'en',
      amp: true
    },
    headAttrs: {},
    bodyAttrs: {}
  },

  data() {
    return {
      addSearchContext: {
        properties: {
          key: ''
        }
      },
      specialMenuCss: false,
      defaultGlobals: null,
      navigation: null,
      socialIcons: []
    }
  },

  async created() {
    // STG key
    this.addSearchContext.properties.key = "29fc80db4a6be01abc29cf38a52d2c24";
    if (process.env.VUE_APP_ADDSEARCH_KEY) {
      this.addSearchContext.properties.key = process.env.VUE_APP_ADDSEARCH_KEY;
    }
    if (this.$cookies.get('xKey') && this.$cookies.get('xKey') !== '') {
      this.$store.dispatch('key/setKey', this.$cookies.get('xKey'));
    }

    if (!this.$store.getters['key/getKey'] && process.env.VUE_APP_M360_KEY) {
      this.$store.dispatch('key/setKey', process.env.VUE_APP_M360_KEY);
    }

    await this.getNavigation();
    // await this.getSocialIcons();
    if (process.env.VUE_APP_TYPE && ['website', 'serve'].includes(process.env.VUE_APP_TYPE.toString().toLowerCase())) {
      await this.getSocialIcons();
    }

    this.$nextTick(() => {
      this.$forceUpdate();
    });
  },

  methods: {

    async rerenderMenu(updatedMenu) {
      if (updatedMenu) {
        this.navigation = updatedMenu;
        await this.checkFixProperties(this.navigation);
        this.$forceUpdate();
      }
    },

    async getNavigation() {
      const self = this;
      if (process.env.VUE_APP_TYPE !== 'widget') {
        this.testLogin();
        if (this.$route.query && this.$route.query.firstVisit) {
          this.showPopUp = true;
          if (this.$store.getters['auth/getUser']) {
            this.showPopUp = false;
          }
        }
      }

      async function checkMyWidget() {
        return self.checkWidget()
            .then(response => {
              self.$store.dispatch('auth/setWidget', response);

              if (response.AllowAccess === true) {
                return getData();
              } else {
                self.$router.push({name: "error404"});
              }
            })
            .catch(error => {
              console.error(error);
            });
      }

      if (process.env.VUE_APP_TYPE === 'widget') {
        // Check if the requesting URL is allowed for this widget KEY
        await checkMyWidget();
      } else {
        return getData();
      }

      async function getData() {
        self.navigation = null;
        self.defaultGlobals = null;

        const requestOptions = {
          url: '/abcbridgeapi/',
          method: 'post',
          body: {
            layout: true
          },
          qs: {
            ignoreUser: true
          }
        };

        return self.getSendData(requestOptions)
            .then(response => {
              self.navigation = response.menu;
              self.defaultGlobals = {
                chromeThemeColor: response.chromeThemeColor,
                description: response.description,
                favicon: response.favicon,
                footer: response.footer,
                header: (response.global) ? response.global.header : null,
                global: response.global,
                msTilePicker: response.msTilePicker,
                pageImage: response.pageImage,
                searchEngineCrawl: response.searchEngineCrawl || true,
                searchEngineVisible: response.searchEngineVisible,
                title: response.title
              };

              self.$forceUpdate();
            })
            .catch(error => {
              if (error.message === "Invalid auth token!") {
                console.warn("Invalid token !!!!");
                self.LogoutCookies();
              } else if (error && error.errors && error.errors[132] && error.errors[132].message) {
                self.clearMessages();
                self.licenseError();
              } else {
                console.error(error);
              }
            });
      }

    },

    async getSocialIcons() {
      this.socialIcons = [];

      const requestOptions = {
        url: '/abcbridgeapi/',
        method: 'post',
        qs: {
          ignoreUser: true
        },
        body: {
          list: true,
          meta: {
            "type": "dataIcon",
            "parent": "data-collections/icons/social-icons/",
            "depth": 0,
            "page": 0,
            "pageSize": 10
          }
        }
      };

      return this.getSendData(requestOptions)
          .then(response => {
            this.socialIcons = response.items;
          })
          .catch(error => {
            if (error && error.errors && error.errors[132] && error.errors[132].message) {
              this.clearMessages();
              this.licenseError();
            } else console.error(error);
          });
    },

    handleShowLoading: function (loadingValue) {
      this.globalLoading = loadingValue;
      this.$forceUpdate();
    },

    headerSuppressed: function () {
      this.specialMenuCss = true;
    }
  }
};
</script>

<style>

section.navbar-section {
  position: initial;
  display: contents;
}
</style>